import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import { MaterialReactTable } from "material-react-table";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MenuItem } from "@mui/material";
import { LabelText } from "../Utils/Input";
import { fetchAllPartner } from "../../slices/PartnerMangement/thunk";
import { customerIdData } from "../Customers/constants/constantFunctionsView";
import { partnerListForPolicy } from "./Constants/PolicyColumns";
import {
  addPartnerDataUsingDispatch,
  createPartnerDataFunction,
  mergeAndFilterPartners,
} from "./Constants/ModifyPolicyDataFunctions";
import moment from "moment";

export const PartnerList = ({
  values,
  partnerId,
  mergedPartners,
  setMergedPartners,
  selectedOffers,
}) => {
  const [rowSelection, setRowSelection] = useState({});
  const PartnerData = useSelector((state) => state.Partner.partner);
  const isEdit = location.pathname.includes("update-policy");
  const policyId = customerIdData();
  const [loading, setLoading] = useState(false);
  const [partnerDeleted, setPartnerDeleted] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const PartnerMainId = partnerId;
  const column = partnerListForPolicy(dispatch, setPartnerDeleted);
  const [partnerDataArray, setPartnerDataArray] = useState([]);
  const settlementPartner = useSelector(
    (state) => state.SelectedPartner.settlementPartner
  );
  let commissionRules = values?.commissionRules;
  let policyIdVal = values?.policyName;
  let priority = values?.priority;

  useEffect(() => {
    dispatch(fetchAllPartner(setLoading));
  }, [dispatch]);

  const filteredArray = partnerId;
  useEffect(() => {
    if (!isEdit) {
      createPartnerDataFunction(PartnerData, partnerId, setPartnerDataArray);
    }
  }, [isEdit, PartnerData, partnerId]);

  useEffect(() => {
    if (!partnerDeleted && !isEdit) {
      addPartnerDataUsingDispatch(
        filteredArray,
        partnerDataArray,
        dispatch,
        settlementPartner,
        isEdit
      );
    }
    //future use
    // if(!mergedPartners.length && filteredArray?.length > 0 ){
    mergeAndFilterPartners(settlementPartner, setMergedPartners);
    // }
  }, [
    dispatch,
    filteredArray,
    settlementPartner,
    partnerDataArray,
    partnerDeleted,
    isEdit,
    setMergedPartners,
  ]);

  return (
    <div className="mb-3 mt-1 table-responsive">
      <div className="d-flex mb-2">
        <h4 className="card-title mb-0 flex-grow-1">Partner List</h4>
        <Button
          color="secondary"
          className={
            "justify-content-end btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-md-auto ms-auto text-nowrap"
          }
          onClick={() => {
            if (!isEdit) {
              navigate("/partner-for-policy", {
                state: {
                  selectedOffers,
                  values,
                  commissionRules,
                  policyIdVal,
                  priority,
                },
              });
            } else {
              navigate("/update-partner-for-policy", {
                state: { partnerId, policyId, selectedOffers },
              });
            }
          }}
        >
          <i className="ri-add-fill label-icon align-middle fs-16 me-2"></i>
          <span className="px-2 ps-3 ms-2 me-1 fw-bold">Add</span>
        </Button>
      </div>
      <div className="border">
        <MaterialReactTable
          displayColumnDefOptions={{
            "mrt-row-actions": {
              header: "",
              enableHiding: true,
              size: 52,
              grow: true,
            },
          }}
          defaultColumn={{
            minSize: 10,
            maxSize: 9001,
            muiTableBodyCellProps: {
              sx: {
                fontFamily: "Inter,sans-serif",
              },
            },
            muiTableHeadCellProps: {
              sx: {
                fontFamily: "Inter,sans-serif",
              },
            },
          }}
          enableTopToolbar={false}
          enableBottomToolbar={true}
          enableDensityToggle={false}
          enableColumnActions={true}
          getRowId={(row) => row.partnerId}
          onRowSelectionChange={setRowSelection}
          state={{ rowSelection }}
          columns={column}
          data={mergedPartners}
        />
      </div>
    </div>
  );
};
